/*@flow*/
import Present from 'lib/Present';
import isEmbedded from 'lib/isEmbedded';
import { useState, useEffect } from 'react';
import useContextState from './useContextState';
import useCommands from './useCommands';

export default function useSections(filters: {
  type?: string[],
}): Array<string> {
  const [isLoaded, setLoaded] = useState(false);
  const { filtersSectionsOriginal } = useContextState();
  const cmd = useCommands();
  let sections = filters.type || [];

  // Save original sections if embedded
  useEffect(() => {
    if (!isEmbedded()) return;
    if (sections.filter((v) => v !== 'foo').length === 0) return;
    if (isLoaded) return;
    setLoaded(true);
    cmd.set(['filtersSectionsOriginal'], sections);
  }, [isLoaded]);

  // Retrieve the original sections if embedded.
  // If embedded, use the original section filters, else use resourceTypes in filters.
  if (isEmbedded()) {
    sections = Present.is(filtersSectionsOriginal)
      ? filtersSectionsOriginal
      : sections;
  }

  return sections;
}
